
/**
 * 统一枚举
 */
export namespace enums {
    /**发货方状态 */
    export const shipStateType: Types.EnumObject[] = [
        { key: '1', value: true, label: '启用' },
        { key: '2', value: false, label: '禁用' },
    ];
    export const succcess: Types.EnumObject[] = [
        { key: '', value: '', label: '全部' },
        { key: '1', value: true, label: '成功' },
        { key: '2', value: false, label: '失败' },
    ];
    /**地址 */
    export const interfaceType1: Types.EnumObject[] = [
        { key: '', value: '', label: '全部' },
        { key: '1', value: 1, label: '车辆新增修改' },
        { key: '1', value: 2, label: '车辆删除' },
        { key: '1', value: 3, label: '司机新增修改' },
        { key: '1', value: 4, label: '司机删除' },
        { key: '1', value: 5, label: '子单新增修改' },
        { key: '1', value: 6, label: '截单' },
        { key: '1', value: 7, label: '派车单生成' },
    ];
    /**地址 */
    export const interfaceType2: Types.EnumObject[] = [
        { key: '', value: '', label: '全部' },
        { key: '1', value: 1, label: '车辆新增修改' },
        { key: '1', value: 2, label: '车辆删除' },
        { key: '1', value: 3, label: '司机新增修改' },
        { key: '1', value: 4, label: '司机删除' },
        { key: '1', value: 5, label: '配车' },
        { key: '1', value: 6, label: '确认调度' },
    ];
    /**地址 */
    export const stateType: Types.EnumObject[] = [
        { key: '1', value: true, label: '启用' },
        { key: '2', value: false, label: '禁用' },
    ];
    /**地址 */
    export const addressType: Types.EnumObject[] = [
        { key: '1', value: '1', label: '发货地址' },
        { key: '2', value: '2', label: '收货地址' },
    ];
    /**询价方式 */
    export const inquiryType: Types.EnumObject[] = [
        { key: '1', value: '1', label: '定向询价' },
        { key: '2', value: '2', label: '公开询价' },
    ];

    /**回单状态 */
    export const receiptStatusType: Types.EnumObject[] = [
        { key: '0', value: '0', label: '全部' },
        { key: '1', value: '1', label: '无回单' },
        { key: '2', value: '2', label: '回单待回' },
        { key: '3', value: '3', label: '回单部分已回' },
        { key: '4', value: '4', label: '回单已回' },
        { key: '5', value: '5', label: '货损回单' },
        { key: '6', value: '6', label: '回单缺页' },
        { key: '7', value: '7', label: '回单已上传' },
    ];
    /**状态 */
    export const statusType: Types.EnumObject[] = [
        { key: '', value: '', label: '全部' },
        { key: '1', value: '1', label: '待应用' },
        { key: '2', value: '2', label: '应用中' },
        { key: '3', value: '3', label: '已失效' },
    ];
    export const priceListType: Types.EnumObject[] = [
        { key: '1', value: 1, label: '线路-车长' },
        { key: '3', value: 3, label: '线路-吨位范围' },
        { key: '2', value: 2, label: '线路-吨位' },
    ];
    /**状态 */
    export const statusType2: Types.EnumObject[] = [
        { key: '0', value: '0', label: '全部' },
        { key: '1', value: '1', label: '派车中' },
        { key: '5', value: '5', label: '待发货' },
        { key: '6', value: '6', label: '已发货' },
        { key: '7', value: '7', label: '已送达' },
        { key: '8', value: '8', label: '已终结' },
    ];
    /**
     * 车长枚举
     */
    export const carLengthType: Types.EnumObject[] = [
        { key: '16', value: '16', label: '3.8米' },
        { key: '1', value: '1', label: '4.2米' },
        { key: '2', value: '2', label: '5.8米' },
        { key: '3', value: '3', label: '6米' },
        { key: '4', value: '4', label: '6.2米' },
        { key: '5', value: '5', label: '6.5米' },
        { key: '6', value: '6', label: '6.8米' },
        { key: '7', value: '7', label: '7.6米' },
        { key: '17', value: '17', label: '7.7米' },
        { key: '18', value: '18', label: '8.2米' },
        { key: '8', value: '8', label: '8.6米' },
        { key: '9', value: '9', label: '8.7米' },
        { key: '10', value: '10', label: '9.6米' },
        { key: '19', value: '19', label: '11.7米' },
        { key: '20', value: '20', label: '12.5米' },
        { key: '11', value: '11', label: '13米' },
        { key: '12', value: '12', label: '13.5米' },
        { key: '22', value: '22', label: '13.75米' },
        { key: '21', value: '21', label: '15米' },
        { key: '13', value: '13', label: '16米' },
        { key: '14', value: '14', label: '17.5米' },
        { key: '23', value: '23', label: '22.5米' },
        { key: '15', value: '15', label: '其他' },
    ];
    /**
     * 车型枚举
     */
    export const carType: Types.EnumObject[] = [
        { key: '1', value: '1', label: '厢车' },
        { key: '2', value: '2', label: '飞翼' },
        { key: '3', value: '3', label: '半挂' },
        { key: '4', value: '4', label: '标厢' },
        { key: '5', value: '5', label: '大平板' },
        { key: '6', value: '6', label: '平板' },
        { key: '7', value: '7', label: '高低板' },
        { key: '8', value: '8', label: '高栏平板' },
        { key: '9', value: '9', label: '高栏高低板' },
        { key: '10', value: '10', label: '大件车抽拉板' },
        { key: '11', value: '11', label: '大件车超低板' },
        { key: '12', value: '12', label: '自卸车' },
        { key: '13', value: '13', label: '单车' },
        { key: '15', value: '15', label: '拖车（集装箱）' },
        { key: '14', value: '14', label: '其他' },
    ];
    /**承运方式 */
    export const carrierCategoryType: Types.EnumObject[] = [
        { key: '1', value: 1, label: '整车' },
        { key: '2', value: 2, label: '零担' },
    ];
    export const chargeTypeList: Types.EnumObject[] = [
        { key: '1', value: 1, label: '线路-车长' },
        // { key: '2', value: 2, label: '元/吨' },
        // { key: '3', value: 3, label: '元/公里' },
    ];
    export const grossWeight: Types.EnumObject[] = [
        { key: '1', value: 1, label: '吨' },
        { key: '2', value: 2, label: '立方' },
        { key: '3', value: 3, label: '车' },
        { key: '4', value: 4, label: '件' },
        { key: '5', value: 5, label: '托' },
        { key: '6', value: 6, label: '台' },
        { key: '7', value: 7, label: '其他' },
    ];
    /**装车要求 */
    export const loadingType: Types.EnumObject[] = [
        { key: '1', value: '1', label: '防水防潮' },
        { key: '2', value: '2', label: '装载均匀' },
        { key: '3', value: '3', label: '捆扎牢固' },
        { key: '4', value: '4', label: '不得混装' },
        { key: '5', value: '5', label: '避免重压' },
        { key: '6', value: '6', label: '易碎物品' },
        { key: '7', value: '7', label: '注意遮光' },
        { key: '8', value: '8', label: '防污防腐' },
        { key: '9', value: '9', label: '异形异件' },
        { key: '10', value: '10', label: '易燃物品' },
        { key: '11', value: '11', label: '防寒' },
        { key: '12', value: '12', label: '不超长不超宽不超高' },
        { key: '13', value: '13', label: '其他' },
    ];
    /**货物数量单位 */
    export const goodsUnitType: Types.EnumObject[] = [
        { key: '1', value: '1', label: '吨' },
        { key: '2', value: '2', label: '立方' },
        { key: '3', value: '3', label: '车' },
        { key: '4', value: '4', label: '件' },
        { key: '5', value: '5', label: '托' },
        { key: '6', value: '6', label: '台' },
        { key: '7', value: '7', label: '其他' },
    ];
    /**货物数量单位 */
    export const grossWeightList: Types.EnumObject[] = [
        { key: '1', value: 1, label: '吨' },
        { key: '2', value: 2, label: '立方' },
        { key: '3', value: 3, label: '车' },
        { key: '4', value: 4, label: '件' },
        { key: '5', value: 5, label: '托' },
        { key: '6', value: 6, label: '台' },
        { key: '7', value: 7, label: '其他' },
    ];
    /**运单状态 */
    export const wayBillStatusType: Types.EnumObject[] = [
        // { key: '0', value: '0', label: '待派车' },
        { key: '1', value: '1', label: '待发货' },
        { key: '2', value: '2', label: '在途中' },
        { key: '3', value: '3', label: '已送达' },
        { key: '4', value: '4', label: '已终结' },
    ];
    /**回单中运单状态 */
    export const receiptWayBillStatusType:Types.EnumObject[] = [
        { key: '1', value: '1', label: '待发货' },
        { key: '2', value: '2', label: '在途中' },
        { key: '3', value: '3', label: '已送达' },
        // { key: '4', value: '4', label: '已终结' },
    ]



    /**
    * 车长枚举
    */
    export const carLengthTypeNum: Types.EnumObject[] = [
        { key: '16', value: 16, label: '3.8米' },
        { key: '1', value: 1, label: '4.2米' },
        { key: '2', value: 2, label: '5.8米' },
        { key: '3', value: 3, label: '6米' },
        { key: '4', value: 4, label: '6.2米' },
        { key: '5', value: 5, label: '6.5米' },
        { key: '6', value: 6, label: '6.8米' },
        { key: '7', value: 7, label: '7.6米' },
        { key: '17', value: 17, label: '7.7米' },
        { key: '18', value: 18, label: '8.2米' },
        { key: '8', value: 8, label: '8.6米' },
        { key: '9', value: 9, label: '8.7米' },
        { key: '10', value: 10, label: '9.6米' },
        { key: '19', value: 19, label: '11.7米' },
        { key: '20', value: 20, label: '12.5米' },
        { key: '11', value: 11, label: '13米' },
        { key: '12', value: 12, label: '13.5米' },
        { key: '22', value: 22, label: '13.75米' },
        { key: '21', value: 21, label: '15米' },
        { key: '13', value: 13, label: '16米' },
        { key: '14', value: 14, label: '17.5米' },
        { key: '23', value: 23, label: '22.5米' },
        { key: '15', value: 15, label: '其他' },
    ];
    /**
     * 车型枚举
     */
    export const carTypeNum: Types.EnumObject[] = [
        { key: '1', value: 1, label: '厢车' },
        { key: '2', value: 2, label: '飞翼' },
        { key: '3', value: 3, label: '半挂' },
        { key: '4', value: 4, label: '标厢' },
        { key: '5', value: 5, label: '大平板' },
        { key: '6', value: 6, label: '平板' },
        { key: '7', value: 7, label: '高低板' },
        { key: '8', value: 8, label: '高栏平板' },
        { key: '9', value: 9, label: '高栏高低板' },
        { key: '10', value: 10, label: '大件车抽拉板' },
        { key: '11', value: 11, label: '大件车超低板' },
        { key: '12', value: 12, label: '自卸车' },
        { key: '13', value: 13, label: '单车' },
        { key: '15', value: 15, label: '拖车（集装箱）' },
        { key: '14', value: 14, label: '其他' },
    ];
    /**承运方式 */
    export const carrierCategoryTypeNum: Types.EnumObject[] = [
        { key: '1', value: 1, label: '整车' },
        { key: '2', value: 2, label: '零担' },
    ];
    /**装车要求 */
    export const loadingTypeNum: Types.EnumObject[] = [
        { key: '1', value: 1, label: '防水防潮' },
        { key: '2', value: 2, label: '装载均匀' },
        { key: '3', value: 3, label: '捆扎牢固' },
        { key: '4', value: 4, label: '不得漏装' },
        { key: '5', value: 5, label: '避免重压' },
        { key: '6', value: 6, label: '易碎物品' },
        { key: '7', value: 7, label: '注意遮光' },
        { key: '8', value: 8, label: '防污防腐' },
        { key: '9', value: 9, label: '异形异件' },
        { key: '10', value: 10, label: '易燃物品' },
        { key: '11', value: 11, label: '防寒' },
        { key: '12', value: 12, label: '不超长不超宽不超高' },
        { key: '13', value: 13, label: '其他' },
    ];
    /**货物数量单位 */
    export const goodsUnitTypeNum: Types.EnumObject[] = [
        { key: '1', value: 1, label: '吨' },
        { key: '2', value: 2, label: '立方' },
        { key: '3', value: 3, label: '车' },
        { key: '4', value: 4, label: '件' },
        { key: '5', value: 5, label: '托' },
        { key: '6', value: 6, label: '台' },
        { key: '7', value: 7, label: '其他' },
    ];

    /**待接单查询状态  0,2,3全部 */
    export const inquiryStatusType: Types.EnumObject[] = [
        { key: '1', value: '1', label: '待报价' },
        { key: '2', value: '2', label: '已终结' },
        { key: '3', value: '3', label: '报价中' },
        { key: '4', value: '4', label: '招标成功' },
        { key: '5', value: '5', label: '招标失败' },
        { key: '6', value: '6', label: '议价中' },
    ];
    export const inquiryStatusType3: Types.EnumObject[] = [
        { key: '1', value: '1', label: '待报价' },
        { key: '2', value: '2', label: '已终结' },
        { key: '3', value: '3', label: '报价中' },
        { key: '4', value: '4', label: '招标结束' },
    ];
    /**已接单查询状态 */
    //   export const inquiryStatusType2: Types.EnumObject[] = [
    //     { key: '0', value: '2,3,4,5,6,7,8,9,10,11,12', label: '全部' },
    //     { key: '1', value: '2,3,4,5,6,7', label: '待报价' },
    //     { key: '2', value: '8,11', label: '待处理' },
    //     { key: '3', value: '9', label: '已中标' },
    //     { key: '4', value: '10', label: '未中标' },
    //     { key: '5', value: '12', label: '已终结' },
    // ];
    export const inquiryStatusType2: Types.EnumObject[] = [
        { key: '0', value: 'a', label: '全部' },
        { key: '1', value: 'b', label: '待报价' },
        { key: '2', value: 'c', label: '待处理' },

        { key: '3', value: 'd', label: '已中标' },
        { key: '4', value: 'e', label: '未中标' },
        { key: '5', value: 'f', label: '已终结' },
    ];
    /**状态 */
    export const isStatusType: Types.EnumObject[] = [
        { key: '1', value: true, label: '启用' },
        { key: '2', value: false, label: '禁用' },
    ];
    /**状态 */
    export const carriageWayType: Types.EnumObject[] = [
        { key: '1', value: 1, label: '长途' },
        { key: '2', value: 2, label: '短驳' },
    ]
    export const pricingModeType: Types.EnumObject[] = [
        { key: '1', value: 1, label: '线路-车长' },
        { key: '3', value: 3, label: '线路-吨位范围' },
        { key: '2', value: 2, label: '线路-吨位' },
    ]
    export const freightUnitType: Types.EnumObject[] = [
        { key: '1', value: 1, label: '元/车' },
        { key: '2', value: 2, label: '元/吨' },
    ]

    /**服务类型 */
    export const positionServiceType: Types.EnumObject[] = [
        { key: '2', value: '2', label: 'LBS定位' },
        { key: '1', value: '1', label: 'LBS开通' },
        { key: '3', value: '3', label: '北斗定位' },
        // { key: '4', value: '4', label: '短信' },
        // { key: '5', value: '5', label: '实名认证' },
    ];
    /**回单状态 */
    export const receiptStatusEnum: Types.EnumObject[] = [
        // { key: '1', value: '1', label: '回单未回' },
        // { key: '2', value: '2', label: '回单已上传' },
        // { key: '3', value: '3', label: '回单已签收' },
        { key: '1', value: '1', label: '回单未上传' },
        { key: '2', value: '2', label: '回单已上传' },
    ];
    /**费用类型 */
    export const costTypeEnum: Types.EnumObject[] = [
        { key: '1', value: '1', label: '运费' },
        { key: '2', value: '2', label: '高速费' },
        { key: '3', value: '3', label: '特殊费用' },
    ];
    /**运单状态 */
    export const waybillStatusEnum: Types.EnumObject[] = [
        { key: '1', value: '1', label: '待发货' },
        { key: '2', value: '2', label: '在途中' },
        { key: '3', value: '3', label: '已送达' },
        { key: '4', value: '4', label: '已终结' },
    ];
    /**账单状态 */
    export const billStatusEnum: Types.EnumObject[] = [
        { key: '1', value: '1', label: '待提交' },
        { key: '2', value: '2', label: '待审核' },
        { key: '3', value: '3', label: '审核退回' },
        { key: '4', value: '4', label: '已审核' },
    ];
    /**企业端账单状态 */
    export const priseBillStatusEnum: Types.EnumObject[] = [
        { key: '1', value: '1', label: '待提交' },
        { key: '2', value: '2', label: '待审核' },
        { key: '3', value: '3', label: '审核退回' },
        { key: '4', value: '4', label: '已审核' },
    ];
    /**运单状态 */
    export const orderStatusEnum: Types.EnumObject[] = [
        { key: '1', value: '1', label: '待发布' },
        { key: '7', value: '7', label: '审核中' },
        { key: '6', value: '6', label: '审核退回' },
        { key: '2', value: '2', label: '待接单' },
        { key: '3', value: '3', label: '发运中' },
        { key: '4', value: '4', label: '已完成' },
        { key: '5', value: '5', label: '已终结' },
    ];
    /**运单状态 */
    export const aacorderStatusEnum: Types.EnumObject[] = [
        { key: '7', value: '7', label: '审核中' },
    ];
    /**开票状态 */
    export const invoiceStatusEnum: Types.EnumObject[] = [
        { key: '1', value: '1', label: '未开票' },
        { key: '2', value: '2', label: '已开票' },
    ];
    export const wayBillHasDoneType: Types.EnumObject[] = [
        { key: '1', value: '1', label: '回单未回' },
        { key: '2', value: '2', label: '回单已上传' },
        { key: '3', value: '3', label: '回单已签收' }
    ];
    /**费用审核状态 */
    export const feeStatusEnum: Types.EnumObject[] = [
        { key: '1', value: '1', label: '待审核' },
        { key: '2', value: '2', label: '审核退回' },
        { key: '3', value: '3', label: '已审核' },
        { key: '4', value: '4', label: '不通过' },
    ];
    /**公告状态 */
    export const notificationStatusEnum: Types.EnumObject[] = [
        { key: '1', value: 1, label: '待发布' },
        { key: '2', value: 2, label: '已发布' },
    ];
    /**公告发布范围 */
    export const releaseRangeEnum: Types.EnumObject[] = [
        { key: '4', value: 4, label: '全局' },
        { key: '1', value: 1, label: '企业内部' },
        { key: '2', value: 2, label: '承运商企业' },
    ];


    //项目状态
    export const projectStatusType: Types.EnumObject[] = [
        { key: '1', value: '1', label: '待执行' },
        { key: '2', value: '2', label: '执行中' },
        { key: '3', value: '3', label: '已完成' },
        { key: '4', value: '4', label: '已终结' },
    ];

    /**日志模块 */
    export const logModuleEnum: Types.EnumObject[] = [
        { key: '1', value: 1, label: '单笔询价' },
        { key: '2', value: 2, label: '发货计划' },
        { key: '3', value: 3, label: '运单管理' },
        { key: '4', value: 4, label: '回单管理' },
        { key: '5', value: 5, label: '费用审核' },
        { key: '6', value: 6, label: '费用对账单' },
    ];
    /**异常状态 */
    export const errorEnum: Types.EnumObject[] = [
        { key: '1', value: 1, label: '异常' },
        { key: '2', value: 2, label: '已撤销' },
    ];
    /**异常来源 */
    export const errorformEnum: Types.EnumObject[] = [
        // { key: '1', value: 1, label: '手工录入' },
        // { key: '2', value: 2, label: '系统生成' },
        { key: '1', value: 1, label: '泰航录入' },
        { key: '2', value: 2, label: '车队录入' },
    ];
    export const auditEnum:Types.EnumObject[] =[
        { key: '1', value: 0, label: '待审核' },
        { key: '2', value: 1, label: '已审核' },
    ]
    /**异常来源 */
    export const freightSourceList: Types.EnumObject[] = [
        { key: '1', value: 1, label: '单笔询价' },
        { key: '2', value: 2, label: '运价表' },
        { key: '3', value: 3, label: '其他' },

    ];

    /**预约状态 */
    export const yyStatusType: Types.EnumObject[] = [
        { key: '1', value: '1', label: '已预约' },
        { key: '2', value: '2', label: '已取消' },
        { key: '3', value: '3', label: '排队中' },
        { key: '4', value: '4', label: '叫号中' },
        { key: '5', value: '5', label: '已过号' },
        { key: '6', value: '6', label: '装卸中' },
        { key: '7', value: '7', label: '已出厂' },
    ];
    /**仓库状态 */
    export const storeState: Types.EnumObject[] = [
        { key: '', value: '', label: '全部' },
        { key: '1', value: true, label: '启用' },
        { key: '2', value: false, label: '禁用' },
    ];
    /**订单类型 */
    export const orderState: Types.EnumObject[] = [
        { key: '', value: '', label: '全部' },
        { key: '3', value: 3, label: '成品纸退货' },
        { key: '1', value: 1, label: '成品纸销售' },
        { key: '2', value: 2, label: '废纸回收' },
        { key: '4', value: 4, label: '设备' },
        { key: '5', value: 5, label: '大宗商品' },
        { key: '6', value: 6, label: '其他' },
    ];
    /**装运单类型 */
    export const shippingOrderState: Types.EnumObject[] = [
        { key: '', value: '', label: '请选择' },
        { key: '1', value: 1, label: '普通单' },
        { key: '2', value: 2, label: '分装单' },
    ];
    /**装运单类型 */
    export const shippingTypeState: Types.EnumObject[] = [
        { key: '', value: '', label: '请选择' },
        { key: '1', value: 1, label: '公路汽运' },
    ];
    /**是否状态 */
    export const istState: Types.EnumObject[] = [
        { key: '', value: '', label: '全部' },
        { key: '1', value: true, label: '是' },
        { key: '2', value: false, label: '否' },
    ];
    /**是否状态 */
    export const istState2: Types.EnumObject[] = [
        { key: '', value: '', label: '请选择' },
        { key: '1', value: true, label: '是' },
        { key: '2', value: false, label: '否' },
    ];
    /**是否状态 */
    export const istState3: Types.EnumObject[] = [
        { key: '1', value: true, label: '是' },
        { key: '2', value: false, label: '否' },
    ];
     /**调度状态 */
     export const ddState: Types.EnumObject[] = [
        { key: '', value: '', label: '全部' },
        { key: '0', value: 0, label: '未确认' },
        { key: '1', value: 1, label: '已确认' },
        { key: '2', value: 2, label: '确认失败' },
    ];
    /**应收审核状态 */
    export const receivableState: Types.EnumObject[] = [
        // { key: '', value: '', label: '全部' },
        { key: '1', value: 1, label: '待对账' },
        { key: '2', value: 2, label: '对账中' },
        { key: '3', value: 3, label: '已对账' },
    ];
        /**费用审核状态 */
        export const auditStatusEnum: Types.EnumObject[] = [
            { key: '2', value: '2', label: '待审核' },
            { key: '3', value: '3', label: '审核退回' },
            { key: '4', value: '4', label: '已审核' },
        ];
        export const auditStatusEnum2: Types.EnumObject[] = [
            { key: '2', value: '1', label: '待审核' },
            { key: '4', value: '2', label: '已审核' },
        ];
        /**配车同步状态 */
     export const syncCarStatus: Types.EnumObject[] = [
        { key: '', value: '', label: '全部' },
        { key: '0', value: 0, label: '未同步' },
        { key: '1', value: 1, label: '同步失败' },
        { key: '2', value: 2, label: '同步成功' },
    ];
}

